module.exports = __webpack_public_path__ + "static/media/video-file.45616b02.png";